import isEmpty from 'lodash/isEmpty';
import * as actionTypes from 'store/action-types';
import { TSECustomerState, Action } from 'shared/interface';
import { PER_PAGE } from 'shared/constants/constants';

const initialState: TSECustomerState = {
	customers: [],
	files: [],
	pagination: {
		current_page: 1,
		from: 1,
		last_page: 1,
		per_page: PER_PAGE,
		to: 1,
		total: 0
	},
	columns: {},
	sort: {
		orderBy: 'desc',
		orderByColumn: 'id'
	},
	closeModal: false
}

const reducer = (state: TSECustomerState = initialState, action: Action): TSECustomerState => {
	switch (action.type) {
		case actionTypes.FETCH_TSE_CUSTOMER_INIT:
		case actionTypes.FETCH_TSE_CUSTOMER_V2_INIT:
			return {
				...state,
				customers: [],
				sort: {
					orderBy: action.payload.orderBy,
					orderByColumn: action.payload.orderByColumn,
				},
				pagination: {
					...state.pagination,
					current_page: isEmpty(action.payload.filters) ? state.pagination.current_page : action.payload.page,
					last_page: isEmpty(action.payload.filters) ? state.pagination.last_page : 1,
				}
			}
		case actionTypes.FETCH_TSE_CUSTOMER_SUCCESS:
		case actionTypes.FETCH_TSE_CUSTOMER_V2_SUCCESS:
			return {
				...state,
				customers: action.payload.items,
				pagination: action.payload.pagination,
				columns: action.payload.columns,
				sort: {
					orderBy: action.payload.query.queryData.orderBy,
					orderByColumn: action.payload.query.queryData.orderByColumn,
				}
			};
		case actionTypes.FETCH_TSE_BACKUP_HISTORY_INIT:
			return {
				...state,
				pagination: {
					...state.pagination,
					total: 0,
				},
				files: []
			}
		case actionTypes.FETCH_TSE_BACKUP_HISTORY_SUCCESS:
			return {
				...state,
				pagination: action.payload.pagination,
				files: action.payload.items
			};
		case actionTypes.RESET_MODAL_STATUS:
			return {
				...state,
				closeModal: false
			}
		default:
			return state;
	}
}

export default reducer;
